import React from "react";
import Section from "../../components/section-items/Section/Section";
import SectionTitle from "../../components/section-items/SectionTitle/SectionTitle";
import StatisticsBlock from "./StatisticsBlock/StatisticsBlock";
import {
    StatisticsBox,
    StatisticsHeader,
    StatisticsRedirect,
    StatisticsTitle,
} from "./Statistics.styles";
import { useHistory } from "react-router";
import StatisticsWebsite from "./StatisticsWebsite/StatisticsWebsite";
import { TEAM_DATE } from "../../utils/info";

const Statistics = () => {
    const history = useHistory();

    return (
        <Section theme={"light"} alignItems={"start"}>
            <StatisticsBox>
                <StatisticsHeader>
                    <SectionTitle>{"STATYSTYKI ZESPOŁU"}</SectionTitle>
                    <StatisticsTitle>
                        {`Nasz zespół działa od ${TEAM_DATE} roku. Nasza `}
                        <StatisticsRedirect
                            onClick={() => history.push("/team")}
                        >
                            {"kadra"}
                        </StatisticsRedirect>
                        {
                            " ciągle się rozwija oraz wyznacza sobie kolejne cele do osiągniecia."
                        }
                    </StatisticsTitle>
                    <StatisticsBlock />
                </StatisticsHeader>
                <StatisticsHeader>
                    <SectionTitle>{"STATYSTYKI STRONY"}</SectionTitle>
                    <StatisticsTitle>
                        {
                            "Odwiedzaj naszą witrynę internetową na bieżąco by śledzić rozwój naszego zespołu."
                        }
                    </StatisticsTitle>
                    <StatisticsWebsite />
                </StatisticsHeader>
            </StatisticsBox>
        </Section>
    );
};

export default Statistics;
